export default __webpack_public_path__ + "static/media/group-meeting.f7b7be25.jpg";